const dynamicLoadPhoneNumberInput = () => import(
  /* webpackChunkName: 'react-phone-number-input' */
  "react-phone-number-input/min"
);
export {
  dynamicLoadPhoneNumberInput
};
//# sourceMappingURL=dynamic-load-phone-number-input.js.map
